export default "__VITE_ASSET__DcL_00DP__"